// src/components/LoginForm.js - With Contact Sales link
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { msalInstance } from "../msalConfig";
import { useAuth } from "../context/AuthContext";
import ContactSales from "./ContactSales";

export default function LoginForm({ productName = "Smart AI Analyzer" }) {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [showContactSales, setShowContactSales] = useState(false);

  const handleLogin = async () => {
    try {
      const response = await msalInstance.loginRedirect({
        scopes: ["openid", "profile", "email"],
        prompt: "select_account"
      });
    } catch (err) {
      console.error("Login error:", err);
    }
  };

  return (
    <>
      <button className="auth-button signin-button" onClick={handleLogin}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M11.4 24H0V12.6h11.4V24zM24 24H12.6V12.6H24V24zM11.4 11.4H0V0h11.4v11.4zm12.6 0H12.6V0H24v11.4z" />
        </svg>
        Sign in with Microsoft Entra ID
      </button>

      <div style={{ marginTop: "1.2rem", textAlign: "center" }}>
        <p style={{ fontSize: "0.75rem", color: "#64748b" }}>
          New to {productName}?{" "}
          <span
            onClick={() => setShowContactSales(true)}
            style={{
              color: "#8b5cf6",
              cursor: "pointer",
              fontWeight: 600,
              textDecoration: "underline",
              transition: "color 0.2s"
            }}
            onMouseEnter={(e) => e.target.style.color = "#a78bfa"}
            onMouseLeave={(e) => e.target.style.color = "#8b5cf6"}
          >
            Contact sales
          </span>
        </p>
      </div>

      {showContactSales && <ContactSales onClose={() => setShowContactSales(false)} productName={productName} />}
    </>
  );
}